export interface OpenAIResponse {
    result?: string
    error?: string
}

export const callOpenAI = async (
    message: any,
): Promise<OpenAIResponse> => {
    //console.log(message)

    const openAIToken = process.env.REACT_APP_OPENAI_TOKEN || ''

    if (!openAIToken) {
        console.error("OpenAI token not found in environment variables.")
        return { error: 'Missing OpenAI token.' }
    }

    try {
        const response = await fetch('https://api.openai.com/v1/chat/completions', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${openAIToken}`,
            },
            body: JSON.stringify({
                model: 'gpt-4o',
                messages: message,
                temperature: 0.5,
                max_tokens: 700,
            })
        })

        if (response.ok) {
            const data = await response.json()
            const result = data.choices[0]?.message?.content.trim()
            return { result };
        } else {
            console.error("Error in response:", response.statusText)
            return { error: "An error occurred while calling the API" }
        }

    } catch (error) {
        console.error('Error calling OpenAI:', error)
        return { error: 'Failed to fetch response from OpenAI' }
    }
}
